import BApp from "../../modules/BApp";
import BForm from "../../modules/BForm";
import BDiaryDayForm from "./BDiaryDayForm";

export default class BDiaryDayMealForm extends BDiaryDayForm
{
	getForm()
	{
		return new BForm(this.el);
	}

	getDiaryDayMealId()
	{
		return parseInt(this.el.dataset.id);
	}

	getEntriesElement()
	{
		return this.el.querySelector(`.profile-diary-day-meal-components`);
	}

	getEntries()
	{
		return this.getEntriesElement().querySelectorAll(`.profile-entry`);
	}

	addEntryHtml(template)
	{
		this.getEntriesElement().innerHTML += template;
	}

	focusLastEntryAmount()
	{
		const entries = this.getEntries();
		const last = entries[entries.length - 1];
		const input = last?.querySelector(".profile-diary-day-meal-component__amount input");
		if (input) {
			input.focus();
			input.select();
		}
	}

	setLoading()
	{
		this.el.classList.add("profile-diary-day-meal-form--loading");
		const loader = this.el.querySelector(".profile-diary-day-meal-form__loading");
		if (loader) {
			loader.hidden = false;
		}
	}

	unsetLoading()
	{
		this.el.classList.remove("profile-diary-day-meal-form--loading");
		const loader = this.el.querySelector(".profile-diary-day-meal-form__loading");
		if (loader) {
			loader.hidden = true;
		}
	}

	updateValues(values)
	{
		if (values?.servings?.formatted || false) {
			try {
				this.el.querySelector(`[name="servings"]`).value = values.servings.formatted;
			} catch (error) {
				// Nevermind.
			}
		}

		if (values?.weight?.formatted || false) {
			try {
				this.el.querySelector(`[name="weight"]`).value = values.weight.formatted;
			} catch (error) {
				// Nevermind.
			}
		}

		const componentSelector = `.profile-diary-day-meal-component`;

		for (let id in values?.ingredients || []) {
			let ingredient = values.ingredients[id];
			let el = this.el.querySelector(`.profile-diary-day-meal-ingredient[data-id="${id}"]`);
			if (!el) continue;
			el.querySelector(`${componentSelector}__amount input`).value = ingredient.practicalQuantity.amount.formatted;
			el.querySelector(`${componentSelector}__unit select`).value = ingredient.practicalQuantity.unit.id;
			el.querySelector(`${componentSelector}__quantity-formatted`).innerHTML = ingredient.baseQuantity.formatted;
			for (let nutrientCode in ingredient.nutrients) {
				el.querySelector(`${componentSelector}__nutrient[data-nutrient-code="${nutrientCode}"] ${componentSelector}__nutrient-amount`).innerHTML = ingredient.nutrients[nutrientCode].amount.formatted;
			}
		}

		for (let id in values?.userIngredients || []) {
			let userIngredient = values.userIngredients[id];
			let el = this.el.querySelector(`.profile-diary-day-meal-user-ingredient[data-id="${id}"]`);
			if (!el) continue;
			el.querySelector(`${componentSelector}__amount input`).value = userIngredient.baseQuantity.amount.formatted;
			el.querySelector(`${componentSelector}__quantity-formatted`).innerHTML = userIngredient.baseQuantity.formatted;
			for (let nutrientCode in userIngredient.nutrients) {
				el.querySelector(`${componentSelector}__nutrient[data-nutrient-code="${nutrientCode}"] ${componentSelector}__nutrient-amount`).innerHTML = userIngredient.nutrients[nutrientCode].amount.formatted;
			}
		}

		for (let id in values?.deliProducts || []) {
			let deliProduct = values.deliProducts[id];
			let el = this.el.querySelector(`.profile-diary-day-meal-deli-product[data-id="${id}"]`);
			if (!el) continue;
			el.querySelector(`${componentSelector}__amount input`).value = deliProduct.baseQuantity.amount.formatted;
			el.querySelector(`${componentSelector}__quantity-formatted`).innerHTML = deliProduct.baseQuantity.formatted;
			for (let nutrientCode in deliProduct.nutrients) {
				el.querySelector(`${componentSelector}__nutrient[data-nutrient-code="${nutrientCode}"] ${componentSelector}__nutrient-amount`).innerHTML = deliProduct.nutrients[nutrientCode].amount.formatted;
			}
		}

		for (let code in values?.nutrients || []) {
			let nutrient = values.nutrients[code];
			try {
				this.el.querySelector(`.profile-diary-day-meal-nutrient[data-code="${code}"] .profile-diary-day-meal-nutrient__amount`).innerHTML = nutrient.formatted;
			} catch (error) {
				// Nevermind.
			}
		}

		BApp.refresh();
	}
}
